import React, { useEffect } from 'react'
import imgLocal from '../../assets/news-events/Local.jpg'
import ImageDescription from '../../Components/ImageDescription/ImageDescription'
import SectionHeader from '../../Components/SectionHeader/SectionHeader'
import TextCaption from '../../Components/TextCaption/TextCaption'
import imgLocal_01 from '../../assets/news-events/Local_01.png';
import imgLocal_02 from '../../assets/news-events/Local_02.png'
import CenterStage from '../../Components/CenterStage/CenterStage'

const Local = () => {

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);
    return (
        <div>

            <div>
                <CenterStage
                    imageSrc={imgLocal}
                    title={"Local or imported stock? What weighs most in the operation?"}
                    paragraph={"Anyone who works in maintenance or engineering knows that when a part breaks, time is against you. Every hour of machine downtime weighs on your pocketbook — and on your schedule. That's why having reliable components that are available at the right time can be the secret to keeping your operation running safely and efficiently."}
                />
            </div>



            <ImageDescription
                paragraph="In practice, this means having a reliable inventory nearby. And that's where a trusted partner makes the difference."
            />

            <ImageDescription
                title="When the component is a few kilometers away, not an ocean away"
                paragraph="Imagine needing a specific hydraulic hose and finding out that it only arrives in at least 30 days — if everything goes well with the import. Difficult, right? Now imagine having that same piece in stock here in Brazil, ready to be delivered the next day."
            />

            <TextCaption

                paragraph="HANSA-FLEX maintains one of the largest local inventories in the industry, with more than 4,500 different models of hydraulic components. It has everything: hoses, fittings, adapters, valves, terminals, filters and much more. And most of it ready for immediate shipment."
            />
<br /><br />
            <ImageDescription
                imageSrc={imgLocal_01}

            />
            <TextCaption
                title="Smart logistics that thinks about your routine"
                paragraph="We know that each operation is different. Therefore, in addition to robust inventory, HANSA-FLEX also invests in efficient logistics. With branches strategically distributed across the country, deliveries arrive quickly — no stress, no surprises."
            />


            <TextCaption

                paragraph="And for those who need total agility, we offer custom hydraulic and pneumatic kits. The components arrive pre-assembled, ready for use. This saves time, reduces the cost of in-house inventory, and simplifies your life on the production line."
            />


            <TextCaption
                title="It's not just about play: it's about having someone to count on"
                paragraph="Availability is important, but so is having someone who understands your process. Therefore, our technical team is always available to guide, suggest solutions and even anticipate needs."
            />


            <TextCaption
                paragraph="Each customer has a fixed contact who knows their operation closely. This way, we can make sure what you need is available — before it's even missing."
            />

            <TextCaption
                title="What's at stake is your productivity"
                paragraph="Relying on imported parts can work... until it doesn't work. All it takes is a delay at customs or an inflated international freight to jeopardize an entire maintenance schedule."
            />
            <TextCaption
                paragraph="With HANSA-FLEX's local inventory, you gain predictability, agility, and control. And this translates directly into fewer downtime, more efficiency, and more peace of mind when making decisions."
            />

<br /><br />
            <ImageDescription
                imageSrc={imgLocal_02}
           
            />

            <TextCaption
                title="Your operation at the heart of decisions"
                paragraph="Want to make your operation more agile, safer and prepared for any unforeseen event? Talk to HANSA-FLEX . We have what you need — in stock, in Brazil and with full technical support."
            />
<br /><br />
        </div>
    )
}

export default Local